import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import * as vehicleEndpoint from "modules/Advert/_redux/vehicleEndpoint";

// Arama tarafı: marka → model kademeli seçim. selectedFilter.vehicleBrand /
// .vehicleModel anahtarlarına ObjectId yazar; backend plugin'i bu anahtarları
// $elemMatch dışında, üst-seviye alanlara map'ler.
function SLBrandModelCascade(props) {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [loadingModels, setLoadingModels] = useState(false);

  const selectedBrandId = selectedFilter?.vehicleBrand || "";
  const selectedModelId = selectedFilter?.vehicleModel || "";

  useEffect(() => {
    let cancelled = false;
    setLoadingBrands(true);
    vehicleEndpoint
      .getBrands()
      .then((res) => {
        if (!cancelled) setBrands(res.data || []);
      })
      .finally(() => !cancelled && setLoadingBrands(false));
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!selectedBrandId) {
      setModels([]);
      return undefined;
    }
    let cancelled = false;
    setLoadingModels(true);
    vehicleEndpoint
      .getModelsByBrand(selectedBrandId)
      .then((res) => {
        if (!cancelled) setModels(res.data || []);
      })
      .finally(() => !cancelled && setLoadingModels(false));
    return () => {
      cancelled = true;
    };
  }, [selectedBrandId]);

  const selectedBrand = brands.find((b) => (b.id || b._id) === selectedBrandId) || null;
  const selectedModel = models.find((m) => (m.id || m._id) === selectedModelId) || null;

  const setBrand = (val) => {
    const id = val ? val.id || val._id : "";
    if (id) {
      props.addFilterBulk({ parent: "vehicleBrand", value: id });
      props.setFilterLabel("vehicleBrand", val.name);
    } else {
      props.removeFilter({ parent: "vehicleBrand" });
      props.removeFilterLabel("vehicleBrand");
    }
    // Marka değişince modeli temizle.
    props.removeFilter({ parent: "vehicleModel" });
    props.removeFilterLabel("vehicleModel");
  };

  const setModel = (val) => {
    const id = val ? val.id || val._id : "";
    if (id) {
      props.addFilterBulk({ parent: "vehicleModel", value: id });
      props.setFilterLabel("vehicleModel", val.name);
    } else {
      props.removeFilter({ parent: "vehicleModel" });
      props.removeFilterLabel("vehicleModel");
    }
  };

  return (
    <aside id={props.filter.id} className="sidebar-filter mt-3 mr-1">
      <div className="acod-body collapse show">
        <div className="acod-content m-0">
          <Autocomplete
            options={brands}
            loading={loadingBrands}
            getOptionLabel={(o) => o.name || ""}
            getOptionSelected={(o, v) => (o.id || o._id) === (v?.id || v?._id)}
            value={selectedBrand}
            onChange={(_, val) => setBrand(val)}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Marka" size="small" />
            )}
            style={{ minWidth: 160, marginBottom: 8 }}
          />
          <Autocomplete
            options={models}
            loading={loadingModels}
            disabled={!selectedBrandId}
            getOptionLabel={(o) => o.name || ""}
            getOptionSelected={(o, v) => (o.id || o._id) === (v?.id || v?._id)}
            value={selectedModel}
            onChange={(_, val) => setModel(val)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={selectedBrandId ? "Model" : "Önce marka"}
                size="small"
              />
            )}
            style={{ minWidth: 160 }}
          />
        </div>
      </div>
    </aside>
  );
}

export default connect(null, { ...categoryRedux.actions })(SLBrandModelCascade);
